"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _ArrowDropDownRounded = _interopRequireDefault(require("@mui/icons-material/ArrowDropDownRounded"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _Button = _interopRequireDefault(require("../../elements/Button/Button"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _excluded = ["parentItem", "childItems"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var DropdownIcon = function DropdownIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "m8.71 11.71 2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H9.41c-.89 0-1.33 1.08-.7 1.71z"
  }));
};
DropdownIcon.defaultProps = {
  className: "MuiSvgIcon-root",
  viewBox: "0 0 24 24",
  'aria-hidden': "true"
};
var StyledMenu = (0, _styledComponents.default)(_Menu.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  color: var(--bf-core-pink) !important;\n  font-family: var(--bf-lead-font);\n  font-weight: 600 !important;\n"])));
var StyledMenuItem = (0, _styledComponents.default)(_MenuItem.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  color: var(--bf-dark-grey) !important;\n  font-family: var(--bf-lead-font) !important;\n  font-weight: 600 !important;\n  \n  &:focus {\n    color: var(--bf-core-pink) !important;\n  }\n"])));
var StyledLink = (0, _styledComponents.default)(_Link.default)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  text-decoration: none;\n"])));
var AlternateDropdownIcon = (0, _styledComponents.default)(_ArrowDropDownRounded.default)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 16px !important;\n  text-align: left !important;\n  color: var(--bf-core-pink);\n"])));
var Dropdown = function Dropdown(_ref) {
  var parentItem = _ref.parentItem,
    childItems = _ref.childItems,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _React$useState = _react.default.useState(null),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    anchorEl = _React$useState2[0],
    setAnchorEl = _React$useState2[1];
  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var buttonContent = _react.default.createElement(_react.default.Fragment, null, parentItem.data.title);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Button.default, {
    transparent: true,
    "aria-controls": "simple-menu",
    "aria-haspopup": "true",
    onClick: handleClick
  }, buttonContent, _react.default.createElement(AlternateDropdownIcon, null)), _react.default.createElement(StyledMenu, {
    id: "simple-menu",
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, childItems.map(function (childItem) {
    return _react.default.createElement(StyledLink, Object.assign({
      href: childItem.data.slug
    }, props), _react.default.createElement(StyledMenuItem, null, childItem.data.title));
  })));
};
var _default = Dropdown;
exports.default = _default;